import { render, staticRenderFns } from "./AddNewDuration.vue?vue&type=template&id=1937a81e&scoped=true"
import script from "./AddNewDuration.vue?vue&type=script&lang=ts"
export * from "./AddNewDuration.vue?vue&type=script&lang=ts"
import style0 from "./AddNewDuration.vue?vue&type=style&index=0&id=1937a81e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1937a81e",
  null
  
)

export default component.exports